



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDBLOGSECTION
// ADDBLOGSECTION


const ADDBLOGSECTION= createAsyncThunk(
  "addBlogSection/addBlogSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addBlogSectionSlice = createSlice({
  name: "addBlogSectionSlice",
  initialState: {
    addBlogSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddBlogSection: (state) => {
        state.addBlogSection.loading = false
        state.addBlogSection.error = false
        state.addBlogSection.data = []
        state.addBlogSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDBLOGSECTION.fulfilled, (state, action) => {
      state.addBlogSection = {
        ...state.addBlogSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDBLOGSECTION.pending, (state, action) => {
      state.addBlogSection = {
        ...state.addBlogSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDBLOGSECTION.rejected, (state, action) => {
      state.addBlogSection = {
        ...state.addBlogSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addBlogSectionAction = {
    ADDBLOGSECTION,
};

export { addBlogSectionAction };
export default addBlogSectionSlice.reducer;
export const {setInitialStateOfaddBlogSection} = addBlogSectionSlice.actions
